import api from '../lib/api';
import type { Paginated } from '../types';
import type { Division, DivisionInput } from '../types/crm';

// Single-record endpoints (show/create/update) return a JSON:API-style envelope:
// `{ data: { id, type, attributes: {...flat record...} } }`. List endpoints return
// flat records directly inside `data`. Mirrors operator.service.ts.

export const divisionService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<Division>> => {
    const response = await api.get<Paginated<Division>>('/divisions', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Division> => {
    const response = await api.get<{ data: { attributes: Division } }>(`/divisions/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: DivisionInput): Promise<Division> => {
    const response = await api.post<{ data: { attributes: Division } }>('/divisions', { division: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<DivisionInput>): Promise<Division> => {
    const response = await api.patch<{ data: { attributes: Division } }>(`/divisions/${id}`, { division: data });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/divisions/${id}`);
  },
};

export default divisionService;
